import getInstanceAxios from "./RequestGlobalConfig";

export default getInstanceAxios(process.env.REACT_APP_API_TIMELINE);
